import React, { useEffect, useRef, useState } from 'react';

const CustomSlider3 = ({
  className,
  banners,
  current,
  setCurrent,
  interval = 3000,
  showSlideCount = 1,
  showPrevBtn = 1,
  showNextBtn = 1,
}) => {
  const sliderRef = useRef(null);

  // Nếu cha không truyền vào thì tự tạo state
  const isControlled = typeof current === 'number' && typeof setCurrent === 'function';
  const [internalCurrent, setInternalCurrent] = useState(0);
  const activeIndex = isControlled ? current : internalCurrent;
  const updateCurrent = (val) => {
    if (isControlled) setCurrent(val);
    else setInternalCurrent(val);
  };

  const [isPause, setIsPause] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [translateX, setTranslateX] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(true);
  const [preventClick, setPreventClick] = useState(false);

  const slideCount = banners.length;

  // Auto-slide
  useEffect(() => {
    const slideInterval = setInterval(() => {
      if (slideCount > 1 && !isPause) nextSlide();
    }, interval);

    return () => clearInterval(slideInterval);
  }, [activeIndex, slideCount, interval, isPause]);

  const prevSlide = () => {
    setIsTransitioning(true);
    const newIndex = (activeIndex - 1 + slideCount) % slideCount;
    updateCurrent(Number.isNaN(newIndex) ? slideCount - 1 : newIndex);
  };

  const nextSlide = () => {
    setIsTransitioning(true);
    const newIndex = (activeIndex + 1) % slideCount;
    updateCurrent(Number.isNaN(newIndex) ? 0 : newIndex);
  };

  // Drag / Swipe handlers
  const handleTouchStart = (e) => {
    setIsDragging(true);
    setIsTransitioning(false);
    setStartX(e.touches[0].clientX);
    setPreventClick(false);
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    const diff = e.touches[0].clientX - startX;
    if (Math.abs(diff) > 5) setPreventClick(true);
    setTranslateX(diff);
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
    setIsTransitioning(true);

    if (translateX > 50) {
      prevSlide();
    } else if (translateX < -50) {
      nextSlide();
    }

    setTranslateX(0);
  };

  const handleMouseDown = (e) => {
    e.preventDefault();
    setIsDragging(true);
    setIsTransitioning(false);
    setStartX(e.clientX);
    setPreventClick(false);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    const diff = e.clientX - startX;
    if (Math.abs(diff) > 5) setPreventClick(true);
    setTranslateX(diff);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    setIsTransitioning(true);

    if (translateX > 50) {
      prevSlide();
    } else if (translateX < -50) {
      nextSlide();
    }

    setTranslateX(0);
  };

  return (
    <div className={className}>
      {/* Slider container */}
      <div
        style={{ position: 'relative', overflow: 'hidden' }}
        ref={sliderRef}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        onMouseMove={(e) => {
          handleMouseMove(e);
          setIsPause(true);
        }}
        onMouseLeave={(e) => {
          if (isDragging) handleMouseUp(e);
          setIsPause(false);
        }}
      >
        {/* Hiển thị số thứ tự slide */}
        <div
          className="slide-count"
          style={{
            position: 'absolute',
            top: 10,
            left: 10,
            backgroundColor: 'rgba(0,0,0,0.5)',
            color: 'white',
            padding: '2px 8px',
            borderRadius: 6,
            fontSize: 14,
            zIndex: 2,
            display: showSlideCount === 1 ? 'block' : 'none',
          }}
        >
          {activeIndex + 1}/{slideCount}
        </div>

        {/* Slider track */}
        <div
          className="slider-track"
          style={{
            display: 'flex',
            transition: isTransitioning ? 'transform 0.4s ease' : 'none',
            transform: `translateX(calc(-${activeIndex * 100}% + ${translateX}px))`,
            height: '100%',
          }}
        >
          {banners.map((banner, index) =>
            banner.image?.match(/\.(mp4|webm|ogg)$/i) ? (
              <video
                key={index}
                className="product-one-img"
                src={banner.image}
                controls
                style={{ minWidth: '100%', width: '100%' }}
              />
            ) : (
              <img
                key={index}
                className="product-one-img"
                src={banner.image}
                alt={`img_${index}`}
                style={{ minWidth: '100%', width: '100%' }}
              />
            )
          )}
        </div>

        {/* Nút điều hướng */}
        <button
          onClick={prevSlide}
          style={{
            position: 'absolute',
            top: '50%',
            left: 10,
            transform: 'translateY(-50%)',
            backgroundColor: 'rgba(0,0,0,0.5)',
            color: 'white',
            border: 'none',
            borderRadius: '50%',
            width: 30,
            height: 30,
            fontSize: 18,
            cursor: 'pointer',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 0,
            opacity: 0.5,
            display: showPrevBtn === 1 ? 'flex' : 'none',
          }}
        >
          &lt;
        </button>

        <button
          onClick={nextSlide}
          style={{
            position: 'absolute',
            top: '50%',
            right: 10,
            transform: 'translateY(-50%)',
            backgroundColor: 'rgba(0,0,0,0.5)',
            color: 'white',
            border: 'none',
            borderRadius: '50%',
            width: 30,
            height: 30,
            fontSize: 18,
            cursor: 'pointer',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 0,
            opacity: 0.5,
            display: showNextBtn === 1 ? 'flex' : 'none',
          }}
        >
          &gt;
        </button>
      </div>
      <div style={{margin: '15px 0 0 0', width: '100%'}}>
          <img
              style={{width: '100%', borderRadius: '15px', border: '3px solid var(--main-color)'}}
              src="/static/images/nha_phan_phoi.png"
              alt=""
          />
      </div>
    </div>
  );
};

export default CustomSlider3;
